import { CoreViewProps, View, classNames, getKey, useDragEvent, useEvent, windowObject } from '@fold-dev/core'
import React, { ReactNode, useContext, useRef } from 'react'
import { TodoSections } from './todo-sections'
import { TodoContext } from './todo.provider'
import { TodoTypes } from './todo.types'
import { useTodoEvent } from './todo.util'
import { FORCE_DISABLE_TASKS } from '../calendar'
import { logger } from '../../helpers'

export const FOLD_TODO_SHIFT_FLAG = 'FOLD_TODO_SHIFT_FLAG'
export const FOLD_SELECTION_CACHE = 'FOLD_SELECTION_CACHE'
export const FOLD_TODO_SECTION_MOUSEOVER_CACHE = 'FOLD_TODO_SECTION_MOUSEOVER_CACHE'

windowObject[FOLD_TODO_SHIFT_FLAG] = false
windowObject[FOLD_SELECTION_CACHE] = {}
windowObject[FOLD_TODO_SECTION_MOUSEOVER_CACHE] = null

export type TodoProps = {
    sections: TodoTypes.Section[]
    toolbar?: (selection: any) => ReactNode
} & CoreViewProps

export const Todo = (props: TodoProps) => {
    const { sections = [], toolbar, ...rest } = props
    const ref = useRef(null)
    const { onTaskMove, onTaskMoveToProject, onSectionMove, selection, setSelection, kanbanMode } =
        useContext(TodoContext)
    const className = classNames(
        {
            'f-todo': true,
            'kanban-mode': kanbanMode,
        },
        [props.className]
    )

    const clearSelection = () => {
        if (Object.keys(selection).length != 0) setSelection({})
    }

    const handleKeyDown = (e) => {
        const { isEscape } = getKey(e)
        if (isEscape) windowObject[FOLD_TODO_SECTION_MOUSEOVER_CACHE] = null
    }

    const handleDragOnDrop = ({ detail }) => {
        logger(detail, window[FORCE_DISABLE_TASKS])

        // this is set in the calendar mouse events
        if (window[FORCE_DISABLE_TASKS]) return

        const { origin, target } = detail

        // move tasks into a project
        if (target.group == 'projects' && origin.group == 'tasks') {
            onTaskMoveToProject({ origin, target, selection })
        }

        // move tasks between each other
        if (target.group == 'tasks' && origin.group == 'tasks') {
            // dropping on an empty section, we manually create the target: todo-section.tsx
            if (
                !!windowObject[FOLD_TODO_SECTION_MOUSEOVER_CACHE] &&
                target.areaId != windowObject[FOLD_TODO_SECTION_MOUSEOVER_CACHE].areaId
            ) {
                onTaskMove({
                    origin,
                    target: {
                        areaId: windowObject[FOLD_TODO_SECTION_MOUSEOVER_CACHE].areaId,
                        index: windowObject[FOLD_TODO_SECTION_MOUSEOVER_CACHE].index,
                        elementId: windowObject[FOLD_TODO_SECTION_MOUSEOVER_CACHE].elementId,
                        moveDirection: 'down',
                    },
                    selection,
                })
            } else {
                onTaskMove({ origin, target, selection })
            }
        }

        // move sections
        if (target.group == 'sections' && origin.group == 'sections') {
            onSectionMove({ origin, target })
        }

        // always clear the selection
        clearSelection()
    }

    const handleClick = (e) => {
        if (!ref.current.contains(e?.target)) {
            //setSelection({})
        }
    }

    useDragEvent('ondrop', handleDragOnDrop)

    useEvent('click', handleClick)
    useEvent('keydown', handleKeyDown)

    return (
        <View
            {...rest}
            ref={ref}
            className={className}>
            <TodoSections sections={sections} />
            {toolbar ? toolbar({ selection }) : null}
        </View>
    )
}
